import {Component, Input, OnInit, Output} from '@angular/core';
import {StandaloneRestModel, ToolbarService, TranslateService} from 'bos-commons';
import {FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';
import {RestService} from '../../shared/rest/rest.service';
import {AlertService} from '../../shared/alert.service';
import {Router} from '@angular/router';
import {AngularEditorConfig} from '@kolkov/angular-editor';
import {HtmlAnchor} from '../admin-links/html-anchor';
import {TitleComponent} from '../title-component';

@Component({
  selector: 'app-html-anchor',
  templateUrl: './html-anchor.component.html',
  styleUrls: ['./html-anchor.component.scss', '../html-page/html-page.component.scss']
})
export class HtmlAnchorComponent extends TitleComponent implements StandaloneRestModel, OnInit {

  @Input()
  public id: number;

  new = false;

  htmlAnchorForm: FormGroup;


  @Output()
  public loaded = new BehaviorSubject(false);

  constructor(
      private restService: RestService,
      protected translateService: TranslateService,
      private alertService: AlertService,
      private router: Router,
      toolbarService: ToolbarService) {
    super(toolbarService, translateService);
  }

  getTitleKey() {
    return  'admin.anchor';
  }


  ngOnInit(): void {
    super.ngOnInit();
    setTimeout(() => {
      if(this.id > 0) {
        this.restService.getHtmlAnchor(this.id).subscribe(value => {
          this.initializeForm(value);
          this.initialized();
        })
      } else {
        this.new = true;
        this.initializeForm();
        this.initialized();
      }
    }, 0)
  }

  private initialized() {
    this.loaded.next(true);
  }

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '300px',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: this.translateService.translateWithArgs("HtmlAnchor.placeholder"),
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      {class: 'arial', name: 'Arial'},
      {class: 'times-new-roman', name: 'Times New Roman'},
      {class: 'calibri', name: 'Calibri'},
      {class: 'comic-sans-ms', name: 'Comic Sans MS'}
    ],
    uploadWithCredentials: true,
    sanitize: false,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
    ]
  };
  inProgress: any;
  success: any;

  private initializeForm(htmlAnchor?: HtmlAnchor) {
    this.htmlAnchorForm = new FormGroup({
      locale: new FormControl(htmlAnchor ? htmlAnchor.locale : '', [Validators.required]),
      anyLanguage: new FormControl(htmlAnchor ? htmlAnchor.anyLanguage : false, []),
      page: new FormControl(htmlAnchor ? htmlAnchor.page : '', []),
      name: new FormControl(htmlAnchor ? htmlAnchor.name : '', [Validators.required]),
      external: new FormControl(htmlAnchor ? htmlAnchor.external : false, []),
      url: new FormControl(htmlAnchor ? htmlAnchor.url : '', []),
      order: new FormControl(htmlAnchor ? htmlAnchor.order : '', [Validators.required])
    }, {validators: this.crossValidator});
    this.htmlAnchorForm.valueChanges.subscribe(() => this.success=false);
    this.triggerValidation();
  }

  private triggerValidation() {
    this.htmlAnchorForm.markAllAsTouched();
  }

  private crossValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
    const external = control.get('external');
    const url = control.get('url');
    const page = control.get('page');

    if(external.value) {
      if(url.value.length === 0) {
        return {'urlRequired': true};
      }
    } else {
      if(page.value.length === 0 ) {
        return {'pageRequired': true};
      }
    }

    return null;
  };

  save() {
    const htmlAnchor = this.htmlAnchorForm.getRawValue() as HtmlAnchor;

    htmlAnchor.id = this.new ? undefined : this.id;

    this.restService.saveAnchor(htmlAnchor).subscribe(() => {
      this.success = true;
      this.inProgress = false;

      this.alertService.success("HtmlAnchor.save.success")

      if(this.new) {
        this.router.navigate(['admin', 'links']);
      }
    }, () => {
      this.success = false;
      this.inProgress = false;
      this.alertService.error("HtmlAnchor.save.error")
    })
  }

  delete() {
    this.restService.deleteAnchor(this.id).subscribe(() => {
      this.alertService.success('HtmlAnchor.delete.success')
      this.router.navigate(['admin', 'links']);
    }, () => {
      this.alertService.error("HtmlAnchor.delete.error")
    });
  }
}
